'use strict';

var i18n = require('i18next');
var EditDomainFiltersTitanHq = require('actions/domainFiltersTitanHq/EditDomainFilters');
var FormView = require('actions/domainFiltersTitanHq/FormView');
var StaticView = require('actions/domainFilters/StaticView');

/**
 * Action configuration for Domain Filters
 */
module.exports = {
  title: i18n.t('actionDomainFilters.title'),
  Model: EditDomainFiltersTitanHq,
  FormView: FormView,
  TextView: StaticView,
};
